import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { buildBaseUri, build404Uri } from "./routes";

const getAuthObj = () => {
  const authFromLocalStorage = window.localStorage.getItem("auth");
  if (authFromLocalStorage) {
    return JSON.parse(authFromLocalStorage);
  }
  return {};
};

const checkIfUserPermitted = (permittedRole) => {
  const user = getUser();

  if (!permittedRole) {
    return true;
  } else if (!user) {
    return false;
  } else {
    const userRole = user.role;
    return userRole === permittedRole;
  }
};

const chatBotAccessList = (userId) => {
  // GAFS member
  const userList = [
    "5ed5ab5fcfd6cc66e0cb228c",
    "5ed5be02cfd6cc66e0cb22a3",
    "5f30fd400375391c2fed08c4",
    "5f30fd6d0375391c2fed08c6",
    "5f3923730375391c2fed08c9",
    "60c01f9d94d29b33579544fd",
    "611fb94205e2d16f88c02197",
    "611fd55805e2d16f88c0219b",
    "611fd58605e2d16f88c0219d",
    "611fd5bc05e2d16f88c0219f",
    "611fd5f205e2d16f88c021a1",
    "611fd62205e2d16f88c021a3",
    "611fd64a05e2d16f88c021a5",
    "611fd67105e2d16f88c021ac",
    "611fd69005e2d16f88c021ae",
    "611fd6e205e2d16f88c021b0",
    "611fd6fc05e2d16f88c021b6",
    "611fd71c05e2d16f88c021b9",
    "611fd73505e2d16f88c021bb",
    "611fd76805e2d16f88c021bd",
    "6120ee3305e2d16f88c02275",
    "613ac69cc2ae8867ae597439",
    "617eaf71429cfb66d22f075d",
    "6180e3dcfbe3be4ae6fd6437",
    "61e62cdea84aa6784c3d81cd",
    "61e7fddaa84aa6784c3d8261",
    "61ebb003a84aa6784c3d8541",
    "61ebb06ca84aa6784c3d8543",
    "62c5081fd6c03875d3110680",
    "6347b370581f99304ad5ea4a",
    "6347b37a581f99304ad5ea4e",
    "64589a345ddfe60f2e041cec",
    "646736bb860d2d5d2fad0b01",
    "646824af860d2d5d2fad26e0",
    "649d074baca6ed14e9565cb8",
    "649d5c0eaca6ed14e9568431",
    "64a0cb05aca6ed14e9570ec9",
    "6120ee3305e2d16f88c02275",
    "662876b3dc199b0d441f335b",
  ];

  return userList.includes(userId);
};

export const initChatBot = (user) => {
  console.log("initChatBot user", user);
  const authFromLocalStorage = getAuthToken();
  if (user.role === "admin" || chatBotAccessList(user._id)) {
    const data = {
      greetingMsg: "Hi I'm Lisa. How can I help you?",
      botName: "Lisa (AI Assitant)",
      projectId: "650f0c22d5f640bb49d8ca21",
      // apiURL: "http://localhost:8005",
      // apiURL: "192.168.0.39:8005",
      apiURL: "https://gpt-api-stg.sernsoft.com",
      chatButtonBackgroundColour: "#000000",
      chatIconColor: "#ffffff",
      userButtonBackgroundColour: "#d7a301",
      userIconColor: "#ffffff",
      primaryColor: "#d7a301",
      clientCredentials: authFromLocalStorage,
    };
    console.log(window.SernsoftBot, 91);
    if (window.SernsoftBot) {
      window.SernsoftBot.init(data);
    }
  }
};

export const getIsUserLoggedIn = () => {
  const authObj = getAuthObj();
  return Object.keys(authObj).length > 0;
};

export const getUser = () => {
  const authObj = getAuthObj();
  return authObj.user || {};
};

export const getAuthToken = () => {
  const authObj = getAuthObj();
  return authObj.token || "";
};

export const setUserAuthObj = (userAuthObj) => {
  window.localStorage.setItem("auth", JSON.stringify(userAuthObj));
};

export const getUserAuthObj = () => {
  const authFromLocalStorage = window.localStorage.getItem("auth");
  if (authFromLocalStorage) {
    return JSON.parse(authFromLocalStorage).user;
  }
  return {};
};

export const deleteUserAuthObj = () => {
  window.localStorage.removeItem("auth");
};

export const useValidateLogin = (options) => {
  const history = useHistory();
  // const user = getUser();
  // const isLoggedIn = !!user.username;
  const user = getUserAuthObj();
  const isLoggedIn = !!user.name;

  useEffect(() => {
    if (!isLoggedIn) {
      // set redirect path
      // if !isLoggedIn && pathname === 'billing-subscription'
      if (window.location.pathname.search("billing-subscription") !== -1) {
        window.localStorage.setItem(
          "redirect_path",
          window.location.pathname + window.location.search
        );
      }

      history.push(buildBaseUri());
    }
  }, [isLoggedIn, history, options.path]);
};

export const useValidateAccessPermission = (permittedRole, options) => {
  const history = useHistory();
  const isPermitted = checkIfUserPermitted(permittedRole);

  useEffect(() => {
    if (!isPermitted) {
      history.push(build404Uri());
    }
  }, [isPermitted, history, options.path]);
};
